import ModelEntity from "../../../domain/entities/ModelEntity";

const fromJson = (model: any): ModelEntity => {
    const lowerCaseName = model.model ? String(model.model).toUpperCase() : "";

    return {
        id: model.id,
        name: lowerCaseName,
    };
};

const toJson = (model: ModelEntity): any => {
    return {
        id: model.id,
        model: model.name,
    };
};

export default {
    fromJson,
    toJson,
};
